//import FuseLoadable
import { FuseLoadable } from "@fuse";
//export ImplAdminConfig
export const ImplAdminConfig = {
  //settings
  settings: {
    //set layout
    layout: {
      //set config as empty object
      config: {}
    }
  },
  //set routes
  routes: [
    {
      path: "/app/payroll/impladmin",
      component: FuseLoadable({
        loader: () => import("./ImplAdmin.js")
      })
    }
  ]
  //end routes
};
